import { render } from "./ContactIconMobile.vue?vue&type=template&id=a030faa2"
import script from "./ContactIconMobile.vue?vue&type=script&lang=js"
export * from "./ContactIconMobile.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__